import IAddOn from "../interfaces/IAddOn"

export const LOW_STOCK_THRESHOLD = 5

export const hasZeroOrBelowStock = (products: IAddOn[]): boolean => {
  return products.some(p => typeof p.inventory_quantity === 'number' && p.inventory_quantity <= 0)
}

export const hasLowStock = (products: IAddOn[]): boolean => {
  return products.some(p => typeof p.inventory_quantity === 'number' && p.inventory_quantity > 0 && p.inventory_quantity < LOW_STOCK_THRESHOLD)
}

export const isOutOfStock = (product: IAddOn): boolean => {
  return product.inventory_quantity !== null && product.inventory_quantity <= 0
}

export const isLowStock = (product: IAddOn): boolean => {
  return product.inventory_quantity !== null && product.inventory_quantity > 0 && product.inventory_quantity < LOW_STOCK_THRESHOLD
}

export const getInventoryWarningMessage = (product: IAddOn): string => {
  if (isOutOfStock(product)) {
    return "Out of stock"
  }
  if (isLowStock(product)) {
    return `Low stock: ${product.inventory_quantity} left`
  }
  return ""
}

export const getInventoryWarningMessages = (products: IAddOn[]): { outOfStock: string; lowStock: string } => {
  return {
    outOfStock: "Some products are out of stock",
    lowStock: "Some products are low in stock"
  }
}
